import * as types from './mutation-types'


export default {
    [types.LOAD_INVOICE_STATUS](state, status) {
        state.status = status
    },


}
